import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import {
  IGlobalRolesState,
  IGlobalTeamsState,
  selectRolesList,
  selectTeams,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import GuestViewPage from '../components/GuestViewPage'
import {
  actionCreators,
  IGuestViewState,
  selectError,
  selectIsLoading,
  selectItem,
  selectPermissions,
  selectShowConfirmDelete,
} from '../modules/guestView'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IGuestViewState &
        ICurrentUserState &
        IGlobalRolesState &
        IGlobalTeamsState
    >({
      error: selectError(),
      isLoading: selectIsLoading(),
      item: selectItem(),
      permissions: selectPermissions(),
      roles: selectRolesList(),
      showConfirmDelete: selectShowConfirmDelete(),
      teams: selectTeams(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(GuestViewPage),
)
